import { config } from '../services/apiServices/config';
import { GlobalRouteNames, SuccessRouteNames } from '../models/Common';
import { getDeviceId } from '../utils';

export const ppoeSettingsLink = 'https://www.briz.ua/help/pppoe-soedinenie-na-pk';
export const electronicCommunicationServicesDocLink =
  'https://www.briz.ua/documents/documents-dogovir-pryiednannya-na-nadannya-elektronnykh-komunikatsiinykh-poslug';
export const extraServicesPriceListDocLink = 'https://www.briz.ua/documents/prices-dodatkovi-poslugy';
export const personalAccountRulesDocLink =
  'https://www.briz.ua/documents/docactions-pravyla-roboty-z-osobystym-kabinetom';
export const appleClientId = process.env.REACT_APP_APPLE_CLIENT_ID;
export const appleLoginRedirectURI = process.env.REACT_APP_APPLE_REDIRECT_URI;
export const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

export const availableLanguages = ['ua', 'en'];
export const defaultLanguage = 'ua';

export const xDeviceId = getDeviceId();

export const chatConfig = {
  livechat: {
    license: process.env.REACT_APP_LIVECHAT_LICENSE,
    defaultLanguage: process.env.REACT_APP_LIVECHAT_DEFAULT_LAGUAGE || 'ua',
    languages: {
      ru: 4,
      en: 3,
      ua: 2,
    },
  },
};

export enum ServiceIDs {
  DedicatedIp = 88,
  Films = 70,
}

export enum CustomerOrderStatuses {
  PENDING = 1,
  PROCESSED = 2,
  DECLINED = 3,
  ERROR = 4,
  CANCELED = 5,
}

export const isBrizTvFeatureEnabled = process.env.REACT_APP_BRIZTV_ENABLED === 'true';
export const isProductTourEnabled = process.env.REACT_APP_PRODUCT_TOUR_ENABLED === 'true';
export const isTwoFactorEnabled = process.env.REACT_APP_TWO_FACTOR_AUTH_ENABLED === 'true';
export const dateForChanging = process.env.REACT_APP_DATE_FOR_CHANGING_SERVICE || '15';
export const googleTMId = process.env.REACT_APP_GTM_ID || '';
export const configMaxCountMonth = 36;
export const configInitCountMonth = 1;
export const suspensionOfServicesIds = [35, 85, 283, 280, 403, 379, 409, 406];
export const availableFilmsUnionType = [1, 5];
export const gigabitShareId = 43;
export const turboGigShareId = 76;
export const share50PercentId = 49;
export const gigabitShareStartDate = process.env.REACT_APP_SHARE_GIG_START_DATE || '2024-09-01 00:00:00 GMT+0300';
export const gigabitShareStopDate = process.env.REACT_APP_SHARE_GIG_STOP_DATE || '2024-10-31 23:59:59 GMT+0300';
export const brizTvShareId = process.env.REACT_APP_BRIZTV_SHARE_ID;

export const macAddressExample = '0A-CF-77-3B-ED-5С';

export const firstPaymentHistoryYear = 2021;
export const currentYear = new Date().getFullYear();
export const toDay = new Date();
export const nextMonth = new Date(toDay.getFullYear(), toDay.getMonth() + 1, 1);

export const PaymentRoutes = [GlobalRouteNames.ServicePayment, GlobalRouteNames.ServiceSuspension];
export const Callbacks = {
  PasswordResetEmail: `${process.env.REACT_APP_HOME || ''}${config.AUTHORIZATION.EMAIL_RESET_CALLBACK}`,
  PasswordResetEmailIsAuth: `${window.location.origin}${config.AUTHORIZATION.EMAIL_RESET_CALLBACK_IS_AUTH}`,
  PaymentError: `${process.env.REACT_APP_HOME || ''}`,
  PasswordResetEmailSuccessSecure: `${process.env.REACT_APP_HOME || ''}`,
  PaymentSuccess: `${process.env.REACT_APP_HOME || ''}${GlobalRouteNames.SuccessPage}${
    SuccessRouteNames.ServiceActivationSuccessfulPage
  }`,
};

export const shareActionID = 37;

export const monthNumbers = [
  { value: 1, label: '1' },
  { value: 2, label: '2' },
  { value: 3, label: '3' },
  { value: 4, label: '4' },
  { value: 5, label: '5' },
  { value: 6, label: '6' },
  { value: 7, label: '7' },
  { value: 8, label: '8' },
  { value: 9, label: '9' },
  { value: 10, label: '10' },
  { value: 11, label: '11' },
  { value: 12, label: '12' },
];

export const defaultAccountView = {
  account_id: 0,
  amo: 0,
  bonus_amo: 0,
  clear_amo: 0,
  total_clear_amo: 0,
  comment: '',
  dsc: 0,
  dsc_percent: 0,
  ex: [],
  ex_amo: [],
  details: {
    service: {
      id: '0',
      name: '',
      amo: 0,
      dsc: 0,
      dsc_percent: 0,
      bonus_amo: 0,
      service_amo: 0,
    },
    services_ex: [],
  },
  fts: 0,
  is_daily: false,
  is_bonus_payment: false,
  name: '',
  num: 0,
  service_amo: 0,
  service_id: 0,
  tts: 0,
};

export const appleClosePopupErrorMessage = 'popup_closed_by_user';
export const appleTriggerNewSignInMessage = 'user_trigger_new_signin_flow';

export const firebaseConfigApiKey = process.env.REACT_APP_FIREBASE_CONFIG_API_KEY;
export const firebaseConfigAuthDomain = process.env.REACT_APP_FIREBASE_CONFIG_AUTH_DOMAIN;
export const firebaseConfigDatabaseURL = process.env.REACT_APP_FIREBASE_CONFIG_DATABASE_URL;
export const firebaseConfigProjectId = process.env.REACT_APP_FIREBASE_CONFIG_PROJECT_ID;
export const firebaseConfigStorageBucket = process.env.REACT_APP_FIREBASE_CONFIG_STORAGE_BUCKET;
export const firebaseConfigMessagingSenderId = process.env.REACT_APP_FIREBASE_CONFIG_MESSAGING_SENDER_ID;
export const firebaseConfigAppId = process.env.REACT_APP_FIREBASE_CONFIG_APP_ID;
export const firebaseConfigMeasurementId = process.env.REACT_APP_FIREBASE_CONFIG_MEASUREMENT_ID;
export const firebaseVapidKey = process.env.REACT_APP_FIREBASE_VAPID_KEY;

export const brizTvInterviewAvailable = process.env.REACT_APP_BRIZ_TV_INTERVIEW_AVAILABLE;
export const brizTvInterviewLink = process.env.REACT_APP_BRIZ_TV_INTERVIEW_LINK;
export const brizTvInterviewBonusAmount = process.env.REACT_APP_BRIZ_TV_INTERVIEW_BONUS_AMOUNT;
export const googlePayIdAvailableFor = process.env.REACT_APP_GOOGLE_PAY_AVAILABLE_FOR || '';
export const applePayIdAvailableFor = process.env.REACT_APP_APPLE_PAY_AVAILABLE_FOR || '';

export const headerNewsAvailable = process.env.REACT_APP_HEADER_NEWS_AVAILABLE || false;
export const headerNewsTextUA = process.env.REACT_APP_HEADER_NEWS_UA || '';
export const headerNewsTextEN = process.env.REACT_APP_HEADER_NEWS_EN || '';
export const headerNewsTextRU = process.env.REACT_APP_HEADER_NEWS_RU || '';
export const headerNewsLinkUA = process.env.REACT_APP_HEADER_NEWS_LINK_UA || '';
export const headerNewsLinkEN = process.env.REACT_APP_HEADER_NEWS_LINK_EN || '';
export const headerNewsLinkRU = process.env.REACT_APP_HEADER_NEWS_LINK_RU || '';

export const googlePayEnvironment = process.env.REACT_APP_GOOGLE_PAY_ENVIRONMENT || 'TEST';
export const googlePayMerchantId = process.env.REACT_APP_GOOGLE_PAY_MERCHANT_ID || '';
export const googlePayMerchantName = process.env.REACT_APP_GOOGLE_PAY_MERCHANT_NAME || 'demo merchant';

export const bonusesDeclinationUA = ['бонус', 'бонуси', 'бонусів'];
export const bonusesDeclinationRU = ['бонус', 'бонуса', 'бонусов'];

export const filmsPrice = process.env.REACT_APP_FILMS_PRICE;
export const dedicatedIpPrice = process.env.REACT_APP_DEDICATED_IP_PRICE;

export const clarityId = process.env.REACT_APP_CLARITY_ID || '';
export const googleLoginURL = process.env.REACT_APP_GOOGLE_LOGIN_URL || '';
export const amountIptvDevices = process.env.REACT_APP_AMOUNT_IPTV_DEVICES || 5;
export const LogRocketKey = process.env.REACT_APP_LOG_ROCKET_KEY || '';
export const LOG_ROCKET_LAUNCH_ID = 'lgrckt';
export const LOG_ROCKET_COOKIE_NAME = 'logrocket';
export const LOG_ROCKET_COOKIE_VALUE = 'logrocket started';

export enum ExtraServicesMap {
  dedicatedIp = 7,
  films = 8,
  client = 4,
  wifiMonitoring = 10,
}

export type ExtraServiceKey = keyof typeof ExtraServicesMap;
export const BRIZ_TV_LINK = process.env.REACT_APP_BRIZTV || 'https://briz.tv';
